import React from 'react';
import {injectIntl} from 'react-intl';
import Nav from './nav';
import PropTypes from 'prop-types';
import {cookies} from '@stubhub/react-cookies';
import {connect} from '@stubhub/react-store-provider';
import controller from './controller';
import GoogleSemMessage from '@stubhub/react-google-sem-message';
import FeatureToggle from '@stubhub/react-feature-toggle';
import '../styles/index.scss';
import LegalBanner from '../../react-legal-banner/LegalBanner';
import {COOKIES} from './config';
import {LOGO_TYPES} from '@stubhub/react-logo';

class SellHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentActive: null,
      isModalSearchActive: false,
      showLegalDisclaimerBanner: false
    };
  }

  closeLegalBanner = () => {
    cookies.set(COOKIES.COOKIE_LEGAL_DISCLAIMER, 0);
    this.setState({
      showLegalDisclaimerBanner: false
    });
  };

  componentDidMount() {
    const showLegalDisclaimerBanner = __CLIENT__ && cookies.get(COOKIES.COOKIE_LEGAL_DISCLAIMER) !== '0';
    this.setState({
      showLegalDisclaimerBanner
    });

    /*
     * TODO: fix functionality for sell-oriented enhanced navigation
     * this.props.loadSubCatNavContent();
     */
  }

  onModalSearchActiveChanged = (isActive) => {
    this.setState({
      isModalSearchActive: isActive
    });
  };

  render() {
    const {isModalSearchActive, showLegalDisclaimerBanner} = this.state;
    // Header class
    let headerCls = 'mh__container';
    headerCls += isModalSearchActive ? ' mh__container--searchActive' : '';
    let {
      isSellLanding,
      screenSize,
      searchBarStyle,
      showSearchBarModal,
      onNavMenuStateChange,
      homepage,
      searchpage,
      langSelector,
      onlyNavSecondary,
      noNavSecondary,
      logoType
    } = this.props;

    // TODO: remove this condition once the minimal merch header has been adapted for desktop breakpoints
    if (searchBarStyle === 'modal' && screenSize !== 'small') {
      searchBarStyle = 'expanded';
    }

    return [
      <header key="header" className={`mh merch_header ${headerCls} mh__searchStyle--${searchBarStyle}`}>
        <div className="mh__banner">
          <FeatureToggle name="sellhub.legalDisclaimer.show">
            {showLegalDisclaimerBanner && <LegalBanner onClose={this.closeLegalBanner} />}
          </FeatureToggle>
        </div>
        <GoogleSemMessage isFeatureOn />
        <Nav
          isSellLanding={isSellLanding}
          searchBarStyle={searchBarStyle}
          homepage={homepage}
          searchpage={searchpage}
          langSelector={langSelector}
          screenSize={screenSize}
          isModalSearchActive={this.state.isModalSearchActive}
          onModalSearchActiveChanged={this.onModalSearchActiveChanged}
          showSearchBarModal={showSearchBarModal}
          onNavMenuStateChange={onNavMenuStateChange}
          onlyNavSecondary={onlyNavSecondary}
          noNavSecondary={noNavSecondary}
          logoType={logoType}
        />
      </header>
    ];
  }
}

SellHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  isSellLanding: PropTypes.bool,
  searchBarStyle: PropTypes.string.isRequired,
  screenSize: PropTypes.string,
  onNavMenuStateChange: PropTypes.func,
  logoType: PropTypes.oneOfType(LOGO_TYPES)
};

SellHeader.defaultProps = {
  searchBarStyle: 'expanded',
  screenSize: 'small'
};

export default connect(controller)(injectIntl(SellHeader));
